import { ApiResponse } from "apisauce";
import { OfficeDataProps } from "src/models/office.model";
import { PayScaleOfficesResponse } from "src/models/payrange.models";
import { PayloadProps } from "src/models/service.models";

import API_URL from "./apiConfig/api.config";
import apiCall from "./apiConfig/apiCall.config";

export async function getPayRangeData(uuid?: string) {
  const url = uuid
    ? API_URL.PAY_RANGE.GET_PAY_RANGE_DATA + "/" + uuid
    : API_URL.PAY_RANGE.GET_PAY_RANGE_DATA;
  return await apiCall.get(url);
}

export async function getOfficePayRangeData(uuid?: string, value?: string) {
  const url =
    API_URL.PAY_RANGE.GET_OFFICE_PAY_RANGE_DATA +
    uuid +
    "?category_uuid=" +
    value;
  return await apiCall.get(url);
}

export async function patchPayRangeData(params: string, data: PayloadProps) {
  return await apiCall.patch(
    API_URL.PAY_RANGE.PATCH_PAY_RANGE_DATA + params,
    data
  );
}

export async function createPayRate(data: unknown) {
  return await apiCall.post(API_URL.PAY_RANGE.CREATE_PAY_RANGE, data);
}

export async function createTransparencyPayRate(data: unknown) {
  return await apiCall.post(
    API_URL.PAY_RANGE.CREATE_TRANSPARENCY_PAY_SCALE,
    data
  );
}

export async function getTransparencyPayScale(uuid: string) {
  return await apiCall.get(API_URL.PAY_RANGE.GET_TRANSPARENCY_PAY_SCALE + uuid);
}

export async function getPayScales() {
  return await apiCall.get(API_URL.PAY_RANGE.GET_PAY_SCALES);
}

export async function switchPayScale(uuid: string, data: PayloadProps) {
  const url = API_URL.PAY_RANGE.SWITCH_PAY_SCALE.replace("{officeUuid}", uuid);
  return await apiCall.patch(url, data);
}
export async function getPayScale(uuid: string) {
  return await apiCall.get(API_URL.PAY_RANGE.GET_PAY_SCALE + uuid);
}

export async function patchPayScale(uuid: string, data: PayloadProps) {
  return await apiCall.patch(API_URL.PAY_RANGE.GET_PAY_SCALE + uuid, data);
}

export async function getPayScaleOffices(
  payScaleUuid: string,
  params?: OfficeDataProps
): Promise<ApiResponse<PayScaleOfficesResponse>> {
  const url = API_URL.PAY_RANGE.GET_PAY_SCALE_OFFICES.replace(
    "{payScaleUuid}",
    payScaleUuid
  );
  return await apiCall.get<PayScaleOfficesResponse>(url, { ...params });
}

export async function getDirectHireFees(payScaleUuid: string) {
  const url = API_URL.PAY_RANGE.GET_DIRECT_HIRE_FEES.replace(
    "{payScaleUuid}",
    payScaleUuid
  );
  return await apiCall.get(url);
}

export async function patchDirectHireFees(
  payScaleUuid: string,
  data: {
    direct_hire_fees: { category_uuid: string; direct_hire_fee: number }[];
  }
) {
  const url = API_URL.PAY_RANGE.PATCH_DIRECT_HIRE_FEES.replace(
    "{payScaleUuid}",
    payScaleUuid
  );
  return await apiCall.patch(url, data);
}

export async function patchTransparencyHourlyEscalations(
  payScaleUuid: string,
  data: {
    hourly_escalations: {
      additional_charge: number;
      category_uuid: string;
      escalation_type: number;
    }[];
  }
) {
  const url = API_URL.PAY_RANGE.PATCH_TRANSPARENCY_HOURLY_ESCALATIONS.replace(
    "{payScaleUuid}",
    payScaleUuid
  );
  return await apiCall.patch(url, data);
}

export async function patchTransparencyFullServiceFees(
  payScaleUuid: string,
  data: {
    full_service_fees: {
      category_uuid: string;
      daily_full_service_fee: number;
    }[];
  }
) {
  const url = API_URL.PAY_RANGE.PATCH_TRANSPARENCY_FULL_SERVICE_FEES.replace(
    "{payScaleUuid}",
    payScaleUuid
  );
  return await apiCall.patch(url, data);
}

export async function patchTransparencyPlacementSupportFees(
  payScaleUuid: string,
  data: {
    placement_support_fees: {
      category_uuid: string;
      placement_support_fee: number;
    }[];
  }
) {
  const url =
    API_URL.PAY_RANGE.PATCH_TRANSPARENCY_PLACEMENT_SUPPORT_FEES.replace(
      "{payScaleUuid}",
      payScaleUuid
    );
  return await apiCall.patch(url, data);
}

export async function patchTransparencyPayrollBurdenPercentage(
  payScaleUuid: string,
  data: { payroll_burden_percentage: number }
) {
  const url =
    API_URL.PAY_RANGE.PATCH_TRANSPARENCY_PAYROLL_BURDEN_PERCENTAGE.replace(
      "{payScaleUuid}",
      payScaleUuid
    );
  return await apiCall.patch(url, data);
}
